import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  updateFacialDeviceDetails(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/device/facial/update", payload).then(
      (res) => {
        return res;
      }
    );
  },
};

export default {
  actions,
};
